import { Divider, Space, Tag } from 'antd'

import { pick } from '@eastcoal/common/utils/object'

import { useAreaTreeStore } from '../Store/hooks'

export const AreaTreeValueTag = () => {
  const { value, setSelectedKeys } = useAreaTreeStore(state =>
    pick(state, ['value', 'setSelectedKeys'])
  )

  return value ? (
    <Space>
      <Divider orientation='vertical' />
      <Tag closable color='gold' onClose={() => setSelectedKeys([])}>
        {value.name}
      </Tag>
    </Space>
  ) : null
}
